import { useMemo } from 'react';
import { usePDPData } from '~/features/product-details/context';

export interface ProductDocument {
    Path: string;
    Name?: string;
}

/**
 * `c_documentationLinks` arrives as a JSON string, so it can be malformed, hold something
 * other than a list, or hold entries without a path. Anything unusable is dropped.
 */
export const useProductDocuments = (): ProductDocument[] => {
    const { product } = usePDPData();
    const documentationLinks = product.c_documentationLinks;

    return useMemo(() => {
        if (!documentationLinks) return [];

        try {
            const parsed = JSON.parse(documentationLinks);

            if (!Array.isArray(parsed)) return [];

            return parsed.filter((entry): entry is ProductDocument => !!entry?.Path);
        } catch {
            return [];
        }
    }, [documentationLinks]);
};
